import { Component } from '@angular/core';

@Component({
	selector: 'app-recommended-badge',
	imports: [],
	templateUrl: './recommended-badge.component.html',
	styleUrl: './recommended-badge.component.scss',
})
export class RecommendedBadgeComponent {}
